import { IBrandRoutes } from './types';
import { LazyRoute, lazyWithFallback } from './util';

const TimsRewards: LazyRoute = lazyWithFallback(() => import('pages/account/tims-rewards'));
const TimCard: LazyRoute = lazyWithFallback(() => import('pages/account/tim-card'));
const Catering: LazyRoute = lazyWithFallback(() => import('components/catering'));
const TimsForGood: LazyRoute = lazyWithFallback(() => import('pages/campaigns/tims-for-good'));
const RollUpTheRim: LazyRoute = lazyWithFallback(() =>
  import('components/roll-up-the-rim/landing-page/landing-page')
);
const RollUpTheRimSharedRollsLandingPage: LazyRoute = lazyWithFallback(() =>
  import('components/roll-up-the-rim/sections/shared/shared-rolls-landing-page')
);
const Reusables: LazyRoute = lazyWithFallback(() =>
  import('components/roll-up-the-rim/reusables/reusables-page')
);
const ScanTimCard: LazyRoute = lazyWithFallback(() => import('pages/scan/tim-card'));
const ScanTimRewards: LazyRoute = lazyWithFallback(() => import('pages/scan/tim-rewards'));

const brandRoutes: IBrandRoutes = {
  'routes.catering': Catering,
  'routes.rollUpTheRim': RollUpTheRim,
  'routes.rollUpTheRimOtherLanguage': RollUpTheRim,
  'routes.rollUpTheRimSharedRolls': RollUpTheRimSharedRollsLandingPage,
  'routes.rollUpTheRimSharedRollsOtherLanguage': RollUpTheRimSharedRollsLandingPage,
  'routes.reusables': Reusables,
  'routes.timCard': TimCard,
  'routes.timsRewards': TimsRewards,
  'routes.scanTimCard': ScanTimCard,
  'routes.scanTimRewards': ScanTimRewards,
  'routes.timsRewardsTab': TimsRewards,
  'routes.tims-for-good-en': TimsForGood,
  'routes.tims-for-good-fr': TimsForGood,
};

export default brandRoutes;
